import { setParametros } from '@src/init-globals'
import con from '@services/connection'

const apiUserConfig = {
  loadConfig: async () => {
    try {
      const data = await con.get('/api/config')
      window.RECEBENDO = true
      window.WHITELABEL = data.white_label
      window.PRODUCAO = data.PRODUCAO
      window.ID_HOTJAR = data.ID_HOTJAR
      window.HAS_BETA_ACCESS = data.HAS_BETA_ACCESS
      const params = {
        escritorio: data.escritorio || { nome: '', id_escritorio: '' },
        colors: {
          primary: data.primary_color,
          'primary-light': data.primary_light,
          'primary-dark': data.primary_dark,
          accent: data.primary_light || data.accent_color,
          second: data.secondary,
          'v-primary-base': data.primary_color,
          'bg-navbar-header': data.bg_navbar_header || '#FFF',
          'bg-navbar': data.bg_navbar || '#030309',
          'text-navbar-active': data.text_navbar_active || data.primary_color,
        },
        officeColors: data.office_colors || {},
        features_access: data.features_access || {},
        office_features_access: data.office_features_access || {},
        logo: data.logo_url,
        // logoBranca: data.logo_url_branca,
        favicon: data.url_favicon,
        // faviconBranca: data.url_favicon_branca,
        backgroundImage: data.bg_url,
      }
      window.PARAMETROS = params
      setParametros(params)

      return {
        ...data,
        ...params,
      }
    } catch (err) {
      console.error('Erro ao carregar configuração', err)
      setParametros({ WHITELABEL: false, PRODUCAO: false })
    }
  },
}

export default apiUserConfig
